"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterstitialsTypes = void 0;
var InterstitialsTypes;
(function (InterstitialsTypes) {
    InterstitialsTypes["FIOC"] = "fioc";
    InterstitialsTypes["RFI"] = "rfi";
    InterstitialsTypes["VERHYS"] = "role";
    InterstitialsTypes["LEGAL"] = "legal";
    InterstitialsTypes["WTD"] = "security";
})(InterstitialsTypes || (exports.InterstitialsTypes = InterstitialsTypes = {}));
//# sourceMappingURL=index.js.map